<template lang="pug">
w-btn-icon.w-btn-back( icon='' v-bind=`{ size, noHover }` v-on='$listeners' )
  i-back( decorative )
</template>

<script lang="js">
import WBtnIcon, { mixin } from './w-btn-icon'
import IBack from 'icons/SkipPrevious'

export default {
  name: 'BackButtonWidget',
  mixins: [ mixin ],
  components: { WBtnIcon, IBack },
  props: {
    paused: {
      type: Boolean,
      default: false,
    },
    noHover: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    togglePause() {
      this.$emit( this.action )
    },
  },
  computed: {}
}
</script>

<style lang="scss">
.w-btn-back {
  
}
</style>
